export class WorkFileConfig{
    workFileDefinitionName = "";
    labID = "";
    constantFileName = "";
    active = false;
    includeHeaders = false;
    continueWithFileConfig = false;
    exportPerProject = false;
    generateFilePerPlate = false;
    skipRows = 0;
    additionalMetaData = "";
    fileFormat = FileFormat.CSV;
    workFileTableDefinitions:Array<WorkFileTableDefinition> = [];
}

export class WorkFileTableDefinition{
    header = "";
    column:number;
    source = "";
}

export enum FileFormat {
    TXT = "TXT",
    CSV = "CSV",
    XLS = "XLS",
    XLSX = "XLSX",
    ZIP = "ZIP"
}

export class WorkFileRequest{
    labID:string;
    horizontal = true;
    arraySize:number = null;
    sampleIDs:string[];
    sourcePlateIDs: string[];
    arrayIDs : string[];
    workFileConfig:WorkFileConfig;
    staticFileContent:any;
}

export class WorkFile {
    filename: string;
    fileContent: Blob;
}

export class SampleFileRequest{
    labID: string;
    fileType: string;
    staticFileContent: any
}
